module.exports = __webpack_public_path__ + "assets/9bb9b1c295c163924b9596c56c0194d8.png";